<template>
  <div
    class="container index-page"
    :class="navInfo.navigateSchema"
    ref="container"
  >
    <!-- 这个放着，可以查看当前的viewType，调试的时候用 -->
    <!-- <div style="position:fixed;left:100px;top:100px;width:200px;height:200px;background:#000;color:#fff;z-index:9999">{{viewType}}</div> -->
    <div
      class="top-wrapper "
      :class="{'nav-type4':showMenu === '3','brand-bg-color':showMenu !== '3'}"
      id="topWrapper"
      :style="navBgStyle"
      ref="topWrapper"
    >
      <div
        class="left-over"
        :style="navLeftBgStyle"
        v-if="navInfo.backgroundImg.left.fileId !== '-1'"
      ></div>
      <div
        class="right-over"
        :style="navRightBgStyle"
        v-if="navInfo.backgroundImg.right.fileId !== '-1'"
      ></div>
      <div
        class="systemInfo"
        id="systemInfo"
        ref="systemInfo"
      >
        <img
          class="icon"
          :src="logoPath"
          v-if="themeInfo.systemLogoInfo"
        />
        <img
          class="font-img"
          :src="fontPath"
          v-if="!themeInfo.fontType"
          :style="fontImgStyle"
        />
        <span
          class="system-name"
          v-else
        >{{ themeInfo.systemName }}</span>
      </div>
      <div class="top-menu-wrapper">
        <!-- nav-type3 连锁 -->
        <HorizontalMenuLinkage
          v-if="showMenu === '2'"
          ref="menu"
          :menus="menus"
          :activeWrapType="activeTabMenu"
          :sysInfoWidth="sysInfoWidth"
        >
        </HorizontalMenuLinkage>
        <!-- nav-type4 教学-->
        <HorizontalMenuEdu
          v-if="showMenu === '3'"
          ref="menu"
          :menus="menus"
          :activeWrapType="activeTabMenu"
          :sysInfoWidth="sysInfoWidth"
        ></HorizontalMenuEdu>
      </div>
      <nav-tab-menu
        v-show="showMenu === '1'"
        class="tab-wrapper"
        @show-all-menu="handleShowAllMenu"
      ></nav-tab-menu>
      <div
        class="tool-bar"
        id="toolBar"
        :class="{'nav-type4':showMenu === '3','nav-type3':showMenu === '2'}"
      >
        <tool-icon
          v-for="item in toolBar"
          :key="item.id"
          :toolInfo="item"
          @open-tool-view="openToolHandler"
        ></tool-icon>
        <a
          href="#"
          class="tool-link data-view"
          :title="item.name"
          v-for="(item, i) in dataViewList"
          :key="i"
          @click.prevent="openViewData(item.id)"
        >
          <img
            class="tool-icon"
            :src="item.logoUrl"
          />
        </a>
        <el-dropdown
          @command="onDownloadClick"
          @visible-change="_coverVideo('download')"
        >
          <span
            class="tool-link"
            :title="$t('indexPage.att_down_title')"
          >
            <i class="h-icon-download"></i>
          </span>
          <el-dropdown-menu
            id="download"
            name="download"
            slot="dropdown"
          >
            <el-dropdown-item
              class="dropdown-item"
              v-for="item in attachments"
              :key="item.code"
              :command="item.code"
            >
              {{ item.name }}
            </el-dropdown-item>
            <el-dropdown-item
              divided
              class="dropdown-item"
              command="more"
            >{{ $t("indexPage.more_text") }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown
          @command="onHelpClick"
          @visible-change="_coverVideo('sysConfig')"
          :hide-on-click="false"
        >
          <span
            class="tool-link"
            :title="$t('common.sys_config')"
          >
            <i class="h-icon-menu_leftbar"></i>
          </span>
          <el-dropdown-menu
            id="sysConfig"
            name='sysConfig'
            slot="dropdown"
          >
            <el-dropdown-item
              class="dropdown-item"
              command="sysConfig"
            >
              <i class="h-icon-setting u-icon-setting" />{{ $t("common.sys_config") }}
            </el-dropdown-item>
            <el-dropdown-item
              class="dropdown-item"
              v-if="productAttribute"
            >
              {{$t('indexPage.summerTime_label')}}
              <el-switch
                style="margin-left:10px;"
                v-model="isEnableDST"
                size="mini"
              ></el-switch>
            </el-dropdown-item>
            <el-dropdown-item
              class="dropdown-item"
              divided
              command="about"
            >
              {{ $t("indexPage.about") }}
            </el-dropdown-item>
            <el-dropdown-item
              class="dropdown-item"
              command="help"
            >
              {{ $t("indexPage.help_down_title") }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <a
          href="#"
          class="tool-link-a u-link-tlnc"
          ref="message"
          v-if="showMessage"
          @mouseenter="handleShowMessage('msg')"
          :title="$t('common.message_tlnc')"
        >
          <span
            class="u-count"
            v-if="unReadMsgCount>0"
          ></span>
          <i class="iconfont iconb_ic_message"></i>
        </a>
        <a
          href="#"
          class="tool-link-a u-link-tlnc"
          v-if="showTodo"
          ref="message"
          @mouseenter="handleShowMessage('todo')"
          :title="$t('common.todo_tlnc')"
        >
          <span
            class="u-count"
            v-if="unTodoCount>0"
          ></span>
          <i class="iconfont iconb_ic_dbrw"></i>
        </a>
        <el-dropdown
          style="top: -3px"
          @command="onDropdownClick"
          @visible-change="_coverVideo('portalConfig')"
          :hide-on-click="false"
        >
          <span class="dropdown-link">
            <i class="h-icon-user prefix"></i>
            <span
              class="username"
              :title="userName"
            >{{ userName }}</span>
            <i class="h-icon-angle_down suffix"></i>
          </span>
          <el-dropdown-menu
            id="portalConfig"
            name="portalConfig"
            slot="dropdown"
          >
            <el-dropdown-item
              class="dropdown-item"
              command="personal-page"
              v-if="showPersonalPage"
            >
              {{$t('indexPage.personal')}}
            </el-dropdown-item>
            <el-dropdown-item
              class="dropdown-item"
              command="portal-management"
              v-if="showManagePage"
            >
              {{ $t("indexPage.portal_config_title") }}
            </el-dropdown-item>
            <el-dropdown-item
              class="dropdown-item"
              v-if="showModifyPassword"
              command="password-edit"
            >{{ $t("indexPage.modify_pwd_title") }}
            </el-dropdown-item>
            <el-dropdown-item class="dropdown-item">
              {{$t('indexPage.memory_label')}}
              <el-switch
                style="margin-left:10px;"
                v-model="rmbHisTab"
                size="mini"
              ></el-switch>
            </el-dropdown-item>
            <el-dropdown-item
              :divided="showManagePage || showModifyPassword"
              class="dropdown-item"
              command="logout"
            >{{ $t("indexPage.logout_title") }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div
      class="bottom-wrapper"
      :class="{'nav-type4':showMenu === '3'}"
      id="bottomWrapper"
    >
      <personal-page
        v-if="viewType === 'personal'"
        class="sub-page-container"
        :class="{'page-show':viewType === 'personal'}"
        ref="personal"
      ></personal-page>
      <template v-if="showMenu==='1'">
        <home-page
          class="sub-page-container"
          :class="{'page-show':viewType === 'home'}"
          ref="homePage"
        ></home-page>
        <view-page
          class="sub-page-container"
          :class="{'page-show':viewType !== 'home'&&viewType !== 'personal'}"
          :userName="userName"
        ></view-page>
      </template>
      <template v-else>
        <home-page
          v-if="viewType === 'home'"
          ref="homePage"
        ></home-page>
        <view-page
          v-else-if="viewType !== 'home'&&viewType !== 'personal'"
          :userName="userName"
        ></view-page>
      </template>
    </div>
    <transition name="slider">
      <div
        class="all-menu-wrapper"
        id="applicationMenuInfo"
        @mouseleave="handleHideMenu"
        v-if="showMenu === '1'"
        v-show="showAllFlag"
      >
        <div class="u-flag"></div>
        <application-menu-info :menus="menus"></application-menu-info>
      </div>
    </transition>
    <need-modify-pwd ref="modifyPwd"></need-modify-pwd>
    <el-dialog
      :title="toolDialogData.name"
      :visible.sync="OpenToolView"
      :area="[900, 600]"
      class="m-tool-view"
    >
      <iframe
        class="m-tool-frame"
        :src="toolDialogData.url"
        frameborder="0"
      ></iframe>
    </el-dialog>
    <portal-about
      :aboutDialog="aboutDialog"
      :aboutInfo="aboutInfo"
      :themeInfo="themeInfo"
      :language="language"
      @changeVisiable="handleChangeAboutDialog"
    ></portal-about>
    <message-view
      ref="messageWrap"
      id="messageWrap"
      :msgOrTodo="msgOrTodo"
      :wrapStatus="messageWrap"
      @refreshCount="_getUnreadCount"
      @close="handleMessageWrapClose"
      v-show="messageWrap"
      :style="`left:${messageWrapPos.left}px;top:${messageWrapPos.top}px`"
    ></message-view>
    <div
      class="m-message-cover"
      @mousemove="handleMessageWrapClose"
      v-if="messageWrap"
    ></div>
    <!-- mps消息推送 -->
    <mps-service
      v-if="showMessage||showTodo"
      :componentSet="['portal.bs.tlnc']"
      @message-get="onMessageGet"
    ></mps-service>
  </div>
</template>

<script>
import API from 'api/api'
import ApiConfig from 'api/config'
import needModifyPwd from 'components/need-modify-pwd/need-modify-pwd'
import navTabMenu from './nav-tab-menu'
import applicationMenuInfo from './application-menu-info'
import { ErrorHandleMixin, LoadingMixin, CoverVideo, resizeFrame } from 'utils/mixin'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import homePage from 'views/home/home'
import personalPage from 'views/personal-page/personal-page'
import viewPage from 'views/view-page/view-page'
import toolIcon from './tool-icon'
import messageView from 'components/widget-tlnc/message-view'
import portalAbout from 'components/portal-about/portal-about'
import mpsService from 'components/mps-service/messager'
import HorizontalMenuEdu from './horizontal-menu-edu'
import HorizontalMenuLinkage from './horizontal-menu-linkage'
import { on, off } from '@hui-pro/utils'
export default {
  name: 'index-page',
  data () {
    return {
      rmbHisTab: false,
      isEnableDST: false,
      navInfo: {
        navigateSchema: 'nav-type1',
        backgroundImg: {
          left: { fileId: '-1' },
          middle: { fileId: '-1' },
          right: { fileId: '-1' }
        }
      },
      menus: [],
      menuLoadedFlag: false,
      indexMenu: null,
      // nowMenu: null,
      activeTabMenuForIndexPage: '',
      showAllFlag: false,
      themeInfo: {
        systemLogoInfo: { path: '' }
      },
      userName: '',
      attachments: [],
      showManagePage: false,
      showPersonalPage: false,
      showSystemConfigPage: false,
      showModifyPassword: false,
      showDataView: false, // 数据可视化页面是否展示
      helpFilePath: '',
      topMenus: {
        list: [],
        more: []
      },
      OpenToolView: false, // 导航工具栏打开弹窗
      toolBar: [], // 导航工具栏数据
      toolMenus: [],
      toolDialogData: {},
      aboutDialog: false,
      messageWrapPos: {
        left: 0,
        top: 0
      },
      messageWrap: false,
      // 关于
      aboutInfo: {},
      msgOrTodo: 'msg',
      dataViewList: [],
      showTodo: false,
      showMessage: false,
      activeIndex: '/index/home',
      language: 'zh_CN',
      // 待办/未读消息数量
      unTodoCount: 0,
      unReadMsgCount: 0,
      productAttribute: false,
      sysInfoWidth: 0

    }
  },
  computed: {
    nowMenu () {
      let menu = this.findMenu(this.menus, this.$storage.session.get(`portal-active-tab-menu-${this.$store.state.userName}`), 'menuId')
      return menu
    },
    ...mapGetters(['tabMenus', 'activeTabMenu', 'viewType']),
    baseUrl () {
      if (ApiConfig) {
        return ApiConfig.baseUrl
      } else {
        return process.env.VUE_APP_BASEURL
      }
    },
    showMenu () {
      const navigateSchema = this.navInfo.navigateSchema
      let navType = navigateSchema === 'nav-type1' ? '1' : navigateSchema === 'nav-type4' ? '3' : '2'
      return navType
    },
    routePath () {
      return (
        '/' +
        this.$route.path
          .split('/')
          .filter(item => item !== '')
          .join('/')
      )
    },
    navBgStyle () {
      if (this.navInfo.backgroundImg.middle.fileId !== '-1') {
        return {
          'background-image': `url(${this.navInfo.backgroundImg.middle.path})`
        }
      } else {
        return {}
      }
    },
    navLeftBgStyle () {
      if (this.navInfo.backgroundImg.left.fileId !== '-1') {
        return {
          width: `${this.navInfo.backgroundImg.left.width}px`,
          'background-image': `url(${this.navInfo.backgroundImg.left.path})`
        }
      } else {
        return {}
      }
    },
    navRightBgStyle () {
      if (this.navInfo.backgroundImg.right.fileId !== '-1') {
        return {
          width: `${this.navInfo.backgroundImg.right.width}px`,
          'background-image': `url(${this.navInfo.backgroundImg.right.path})`
        }
      } else {
        return {}
      }
    },
    logoPath () {
      return this.themeInfo.systemLogoInfo
        ? this.themeInfo.systemLogoInfo.path
        : ''
    },
    fontPath () {
      return this.themeInfo.fontImgInfo ? this.themeInfo.fontImgInfo.path : ''
    },
    fontImgStyle () {
      const _fontImg = this.themeInfo.fontImgInfo
      if (!_fontImg) return {}
      const _height = parseInt(_fontImg.height) < 24 ? _fontImg.height : 24
      return {
        height: `${_height}px`
      }
    }
  },
  watch: {
    routePath (value) {
      this._setActiveMenu()
      if (value === '/index/home') {
        this.$nextTick(() => {
          this.$refs.homePage.initEcharts()
        })
      }
    },
    activeTabMenu (menuId) {
      if (this.navInfo.navigateSchema === 'nav-type1') {
        let viewType = menuId === 'home' ? 'home' : 'view'
        this.setViewType(viewType)
      }
      this._setActiveMenu()
    },
    $route: {
      handler () {
        this._setActiveMenu()
      },
      deep: true
    },
    rmbHisTab (state) {
      this.$storage.set(`rmbHisTab-${this.$store.state.userName}`, state)
    },
    isEnableDST (state) {
      if (state) {
        this.$storage.set('isEnableDST', state)
      } else {
        this.$storage.remove('isEnableDST')
      }
    }
  },
  methods: {
    browserTagChange (e) {
      let visibleState = e.target.visibilityState
      if (visibleState === 'hidden') {
        this.postMsgToActIframe('home')
        this.aboutDialog = false
      } else {
        let menuId = this.$storage.session.get(`portal-active-tab-menu-${this.$store.state.userName}`)
        this.postMsgToActIframe(menuId)
      }
    },
    // 初始化视窗类型viewType，用来区分个人中心、首页、组件页面（iframe）
    initViewType () {
      let viewType = this.$storage.session.get(`viewType-${this.$store.state.userName}`) || 'home'
      this.setViewType(viewType)
    },
    // 根据menuId查找菜单
    findMenu (arr, value, key) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i][key] === value) {
          return arr[i]
        }
        if (arr[i]._hasChild) {
          let _res = this.findMenu(arr[i].children, value, key)
          if (_res) return _res
        }
      }
      return null
    },
    // 获取是否是海外版：true是，flase不是
    getProductAttribute () {
      API.common.getProductAttribute().then(res => {
        this.productAttribute = res.data
      })
    },
    // mps消息推送，触发
    onMessageGet (data) {
      this._getUnreadCount()
    },
    _getUnreadCount () {
      API.common.getUnreadCount().then(res => {
        this.unTodoCount = res.data.todoListCount
        this.unReadMsgCount = res.data.messageNotReadCount
      })
    },
    handleChangeAboutDialog (status) {
      this.aboutDialog = status
      let params = { servFlag: 'tipSize', data: { loginOutConfirm: status } }
      for (let i = 0; i < window.frames.length; i++) {
        window.frames[i].postMessage(JSON.stringify(params), '*')
      }
      if (status) {
        this.postMsgToActIframe('home')
      } else {
        let menuId = this.$storage.session.get(`portal-active-tab-menu-${this.$store.state.userName}`)
        this.postMsgToActIframe(menuId)
      }
    },
    _getMenu (arr, id) {
      let _menu = null
      if (!arr || arr.length === 0 || !id) return _menu
      arr.forEach(item => {
        if (item.menuId === id) {
          _menu = item
        }
      })
      return _menu
    },
    handleMessageWrapClose () {
      this.messageWrap = false
      this._coverVideo('messageWrap')
    },
    getDataViewList () {
      API.dataView.getDataViewList({ isShow: 0, isFilter: 1 }).then(res => {
        this.dataViewList = res.data || []
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    // 打开看板
    openViewData (id) {
      window.open(`${ApiConfig.context}/data-view?key=${id}`)
    },
    // 获取关于
    getAbout () {
      API.common.getAbout().then(res => {
        this.aboutInfo = res.data
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    // 打开消息
    handleShowMessage (type) {
      let pos = this.$refs.message.getBoundingClientRect()
      let l = pos.left
      // let t = pos.top
      this.messageWrapPos.left = l - 360
      this.msgOrTodo = type
      this.messageWrap = true
      this._coverVideo('messageWrap')
    },

    handleOpenAbout () {
      this.aboutDialog = true
    },
    _getToolBar () {
      API.menu.toolBarList().then(res => {
        let _arr = res.data || []
        _arr.forEach(item => {
          if (item.isShow === 0 && (item.url || (item.children && item.children.length > 0))) {
            item.children = item.children || []
            item.url = item.url || ''
            if (item.openType === 0) {
              this.toolMenus.push({
                menuId: item.id,
                name: item.name,
                _path: `/index/view/${item.id}`,
                _hasChild: false,
                children: [],
                fullUrl: item.url
              })
            }
            item.children.forEach(subItem => {
              if (subItem.openType === 0) {
                this.toolMenus.push({
                  menuId: subItem.id,
                  name: subItem.name,
                  _path: `/index/view/${subItem.id}`,
                  _hasChild: false,
                  children: [],
                  fullUrl: subItem.url
                })
              }
            })
            this.toolBar.push(item)
          }
        })
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    _getNavInfo () {
      // 判断是否是导航预览模式，如果是从本地缓存获取配置信息
      if (this.$route.query.npw) {
        this.navInfo = this.$storage.get('nav-info')
        this.setNavigateSchema(this.navInfo.navigateSchema)
        // this.$nextTick(() => {
        //   this.setTopMenus()
        // })
      } else {
        API.navigate
          .query()
          .then(res => {
            this.navInfo = res.data
            this.setNavigateSchema(this.navInfo.navigateSchema)
            // 当处于导航模式一的情况下，将数据还原
            // 将Tab菜单数据从SessionStorage中回填
            this.backfillData().then(res => {
              this.activeTabMenuForIndexPage = res
            })
          })
      }
    },
    _getThemeInfo () {
      // 判断是否是主题预览模式，如果是从本地缓存获取配置信息
      if (this.$route.query.tpw) {
        this.themeInfo = this.$storage.get('theme-info')
        document.getElementById('wiportalTitle').innerText = this.themeInfo.systemName
        this.$nextTick(() => {
          this.sysInfoWidth = document.getElementById('systemInfo').offsetWidth
        })
      } else {
        API.theme
          .query()
          .then(res => {
            this.themeInfo = res.data
          }).then(() => {
            this.sysInfoWidth = document.getElementById('systemInfo').offsetWidth
          })
      }
    },
    _getMenuInfo () {
      let _loadingInstance = this._getLoading()
      API.menu
        .getHomeMenu({
          type: 'app'
        })
        .then(res => {
          _loadingInstance.close()
          // 排除掉快捷菜单
          let _menus = res.data.filter(item => {
            return !item.quick
          })
          // 递归生成对应的路径
          _menus.forEach(item => {
            this._handleMenu('/index/view', item)
          })
          // _menus.forEach(item => {
          //   this.handleShowMenu(item)
          // })
          let temp = this.handleShowMenu(_menus)
          this.menus = JSON.parse(JSON.stringify(temp))
          let tempMenus = this.menus.concat(this.toolMenus)
          // 将处理后的菜单列表放入Vuex
          this.setAppMenus(tempMenus)
          this._setActiveMenu()
          this._initActive()
          // 设置顶部菜单
          // this.setTopMenus()
          this.menuLoadedFlag = true
        })
        .catch(() => {
          _loadingInstance.close()
        })
    },
    handleShowMenu (menus) {
      let _menus = menus.filter(menu => {
        if (menu.children && menu.children.length > 0) {
          let temp = this.handleShowMenu(menu.children)
          menu.children = temp
        }
        return menu.isShow === 0 || menu.menuId === 'home'
      })
      return _menus
    },
    // 因为可能存在跨菜单类型间的跳转，所以在这里先把不同类型的菜单都获取了存vuex
    _getPersonalMenusAndSystemMenus () {
      API.menu
        .getPersonalMenu()
        .then(res => {
          this.setPersonalMenus(res.data)
        })
      API.menu
        .getConfigMenu()
        .then(res => {
          this.setSystemMenus(res.data)
        })
    },
    getTlncMenuId () {
      API.common.getTlncTodoMenuId().then(res => {
        this.setTlncTodoMenuId({ todo: res.data })
      }).catch(err => {
        this.$message.error(err.msg)
      })
      API.common.getTlncMSGMenuId().then(res => {
        this.setTlncMessageMenuId({ msg: res.data })
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    _handleMenu (prex, menu) {
      menu.children = menu.children || []
      menu._hasChild = menu.children.length > 0
      // 寻找出指定为首页的菜单
      if (menu.index) {
        if (!menu.fullUrl || menu.fullUrl.trim() === '') {
          menu._path = '/index/home'
          menu.fullUrl = ''
        }
        this.indexMenu = menu
      }
      if (!menu._path) {
        menu._path = `${prex}/${menu.menuId}`
        if (menu.children.length > 0) {
          menu.children.forEach(item => {
            this._handleMenu(menu._path, item)
          })
        }
      }
    },
    _setActiveMenu () {
      let _path = this.$storage.session.get(`portal-active-tab-menu-${this.$store.state.userName}`)
      if (this.$refs.menu) {
        this.activeIndex = _path
      }
    },
    _initActive () {
      // 如果URL中带有菜单信息，则将这个菜单加入到Tab菜单中
      if (this.nowMenu) {
        this.addTabMenu({
          menu: this.nowMenu,
          closeable: true
        })
      } else {
        this.addTabMenu({
          menu: this.indexMenu,
          closeable: false
        })
      }
    },
    _logout () {
      // 清空SessionStorage中保存的数据
      // this.$storage.session.clear()
      window.location.href = ApiConfig.logoutSrc
    },
    _getBasicInfo () {
      API.common
        .basicInfo()
        .then(res => {
          this.setUserName({ userName: res.data.userName })
          this.userName = res.data.userName || ''
          this.showManagePage = res.data.showManagePage
          this.showPersonalPage = res.data.showPersonalPage
          this.showSystemConfigPage = res.data.showSystemConfigPage
          this.showModifyPassword = res.data.showModifyPassword
          this.showDataView = res.data.showDataVisualization
          this.showTodo = res.data.showTodo
          this.showMessage = res.data.showMessage
          this.language = res.data.language
          this._getAllBreadCrumbsMenu()
        })
        .catch(this._handleError)
    },
    _getAllBreadCrumbsMenu () {
      API.common.getAllBreadCrumbsMenu().then(res => {
        window.allBreadCrumbsMenu = res.data
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    _getAttachmentList () {
      API.common
        .getDownloadAttachment()
        .then(res => {
          if (res.data && res.data.list) {
            for (let i = 0; i < res.data.list.length && i < 5; i++) {
              this.attachments.push(res.data.list[i])
            }
          }
        })
        .catch(this._handleError)
    },
    _getHelpPath () {
      API.common
        .getDownloadHelp()
        .then(res => {
          if (res.data.list && res.data.list.length) {
            this.helpFilePath = res.data.list[0].filePath
          }
        })
        .catch(this._handleError)
    },
    openToolHandler (tool) {
      this.toolDialogData = tool
      this.OpenToolView = true
    },
    handleShowAllMenu () {
      this.showAllFlag = true
      this._coverVideo('applicationMenuInfo')
    },
    // vuex
    ...mapActions(['openMenuStatic', 'setTlncTodoMenuId', 'setTlncMessageMenuId']),
    onDropdownClick (command) {
      // 根据点击的下拉菜单命令触发事件
      if (command === 'portal-management') {
        this.openView('/management')
        this._coverVideo('portalConfig')
      } else if (command === 'password-edit') {
        this.modifyPwd(true)
      } else if (command === 'logout') {
        let params = { servFlag: 'tipSize', data: { loginOutConfirm: true } }
        for (let i = 0; i < window.frames.length; i++) {
          window.frames[i].postMessage(JSON.stringify(params), '*')
        }
        this.postMsgToActIframe('home')
        this.$confirm(this.$t('common.login_out_tips'), {
          confirmButtonText: this.$t('common.confirmBtn_text'),
          cancelButtonText: this.$t('common.cancelBtn_text'),
          type: 'question'
        }).then(() => {
          this._logout()
        }).catch(() => {
          let menuId = this.$storage.session.get(`portal-active-tab-menu-${this.$store.state.userName}`)
          this.postMsgToActIframe(menuId)
          let params = { servFlag: 'tipSize', data: { loginOutConfirm: false } }
          for (let i = 0; i < window.frames.length; i++) {
            window.frames[i].postMessage(JSON.stringify(params), '*')
          }
        })
      } else if (command === 'diy-portal') {
        this.openView('/management/home-configuration?branch=diy-portal')
      } else if (command === 'personal-page') {
        // this.activeTabMenu = 'personal'
        // this.setActiveTabMenu('personal')
        this.setViewType('personal')
        this.$storage.session.set(`viewType-${this.$store.state.userName}`, 'personal')
        this.$refs.menu.activeIndex = ''
      }
    },
    openView (path) {
      window.open(`${ApiConfig.context}${path}`)
    },
    handleHideMenu () {
      this.showAllFlag = false
      this._coverVideo('applicationMenuInfo')
    },
    modifyPwd (flag) {
      this.$refs.modifyPwd.modifyPwd(flag)
    },
    onDownloadClick (command) {
      if (command === 'more') {
        this.openView('/download/attachment')
      } else {
        this.attachments.forEach(item => {
          if (item.code === command) {
            window.open(item.filePath)
          }
        })
      }
      this._coverVideo('download')
    },
    onHelpClick (command) {
      if (command === 'about') {
        this.handleOpenAbout()
      } else if (command === 'help') {
        window.open(this.helpFilePath)
        this._coverVideo('sysConfig')
      } else if (command === 'sysConfig') {
        this.openView('/system-configuration')
        this._coverVideo('sysConfig')
      }
    },
    // 下载帮助文档
    downLoadHelp () {
      window.open(this.helpFilePath)
    },
    setTopMenus () {
      let _totalWidth = this.$refs.topWrapper.getBoundingClientRect().width
      let _systemInfo = this.$refs.systemInfo.getBoundingClientRect().width
      this.topMenus.list = []
      this.topMenus.more = []
      let _maxWidth = _totalWidth - 248 - _systemInfo - 48
      let _sum = 0
      this.menus.forEach(menu => {
        _sum += menu.name.length * 12 + 24
        if (_sum > _maxWidth) {
          this.topMenus.more.push(menu)
        } else {
          this.topMenus.list.push(menu)
        }
      })
    },
    ...mapMutations({
      setNavigateSchema: 'SET_NAVIGATE_SCHEMA',
      setAppMenus: 'SET_APP_MENUS',
      setSystemMenus: 'SET_SYSTEMT_MENUS',
      setPersonalMenus: 'SET_PERSONAL_MENUS',
      postMsgToActIframe: 'POST_MSG_TO_ACTIFRAME',
      setActiveTabMenu: 'SET_ACTIVE_TAB_MENU',
      setViewType: 'SET_VIEW_TYPE'
    }),
    ...mapActions(['addTabMenu', 'backfillData', 'setUserName'])
  },
  mounted () {
    this._getNavInfo()
    this._getThemeInfo()
    this._getMenuInfo()
    this._getToolBar()
    this._getBasicInfo()
    this._getAttachmentList()
    this._getHelpPath()
    this.getDataViewList()
    this.getAbout()
    this.getTlncMenuId()
    this._getUnreadCount()
    this._getPersonalMenusAndSystemMenus()
    window.addEventListener('resize', this._resizeFrame)
    this.getProductAttribute()
    // 页面加载时，从localstorage中获取记忆标签状态rmbHisTab-${state.userName}
    this.rmbHisTab = this.$storage.get(`rmbHisTab-${this.$store.state.userName}`)
    this.isEnableDST = this.$storage.get('isEnableDST')
    // this.initViewType()
    on(document, 'visibilitychange', this.browserTagChange)
  },
  created () {
    let path = `/${this.$route.path
      .split('/')
      .filter(item => item !== '')
      .join('/')}`
    if (path !== '/index/home') {
      path = `/index/view/${path.replace('/index/view/', '').split('/')[0]}`
    }
    this.activeIndex = path
  },
  beforeDestroy () {
    // window.removeEventListener('resize', this.setTopMenus)
    off(document, 'visibilitychange', this.browserTagChange)
    window.removeEventListener('resize', this._resizeFrame)
  },
  mixins: [ErrorHandleMixin, LoadingMixin, CoverVideo, resizeFrame],
  components: {
    navTabMenu,
    applicationMenuInfo,
    needModifyPwd,
    homePage,
    viewPage,
    toolIcon,
    messageView,
    portalAbout,
    mpsService,
    personalPage,
    HorizontalMenuEdu,
    HorizontalMenuLinkage
  }
}
</script>
<style lang="scss" scoped>
@import "~assets/styles/wi-font/iconfont.css";
@import "~assets/styles/mixin.scss";
$nav-height: 56px;
$nav-height-l: 68px;

.index-page.container {
  height: 100%;
  width: 100%;
  min-width: 1280px;
  position: relative;
  .m-message-cover {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 100;
  }

  .top-wrapper {
    /*overflow: hidden;*/
    position: relative;
    background-repeat: repeat-x;
    &.nav-type4 {
      background: #fff;
      border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      .systemInfo {
        padding-top: 14px;
      }
      .system-name {
        color: rgba(0, 0, 0, 0.9) !important;
      }
    }
    .systemInfo {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 99;
      box-sizing: border-box;
      width: auto;
      .icon {
        float: left;
        width: 32px;
        height: 32px;
      }
      .font-img {
        height: 100%;
        width: auto;
        display: inline-block;
        vertical-align: middle;
      }
      .system-name {
        float: left;
        margin-left: 6px;
        color: #fff;
        font-size: 16px;
        line-height: 32px;
        vertical-align: middle;
        white-space: pre;
      }
    }
    .tool-bar {
      position: absolute;
      top: 17px;
      right: 8px;
      color: rgba(255, 255, 255, 1);
      &.nav-type4 {
        top: 12px;
        color: rgba(0, 0, 0, 0.7);
        .username {
          color: rgba(0, 0, 0, 0.7);
        }
        i {
          color: rgba(0, 0, 0, 0.7);
          font-size: 24px;
        }
      }
      &.nav-type3 {
        top: 12px;
        i {
          font-size: 24px;
        }
      }
      .el-dropdown {
        top: 4px;
      }
      i {
        color: rgba(255, 255, 255, 0.8);
        font-size: 24px;
      }
      .tool-link-a {
        position: relative;
        opacity: 0.8;
        filter: alpha(opacity=80);
        margin-right: 8px;
        cursor: pointer;
        text-decoration: none;
        z-index: 102;
        &.sys-link {
          top: 4px;
        }
        &.u-link-tlnc {
          .u-count {
            position: absolute;
            display: block;
            right: 0;
            top: -4px;
            border-radius: 50%;
            width: 8px;
            height: 8px;
            background: #fa3239;
          }
        }
        &:hover {
          opacity: 1;
          filter: alpha(opacity=100);
        }
      }
      .tool-link {
        position: relative;
        margin-right: 8px;
        cursor: pointer;
        text-decoration: none;
        z-index: 102;
        &.data-view {
          top: 1px;
        }
        .u-message {
          display: inline-block;
          width: 16px;
          height: 16px;
          background-image: url("../../assets/images/msg_icon.png");
          background-repeat: no-repeat;
        }
        .tool-icon {
          width: 18px;
          height: 18px;
          cursor: pointer;
          opacity: 0.8;
          &:hover {
            opacity: 1;
          }
        }
      }

      .username {
        display: inline-block;
        max-width: 80px;
        vertical-align: middle;
        position: relative;
        top: -2px;
        color: rgba(255, 255, 255, 0.8);
        overflow: hidden; /*超出部分隐藏*/
        text-overflow: ellipsis; /* 超出部分显示省略号 */
        white-space: nowrap; /*规定段落中的文本不进行换行 */
      }
      .username + .h-icon-angle_down {
        font-size: 16px;
      }
      .dropdown-link {
        opacity: 0.8;
        filter: alpha(opacity=80);
        cursor: pointer;
        &:hover {
          opacity: 1;
          filter: alpha(opacity=100);
        }
        .prefix {
          margin-right: 8px;
          position: relative;
          top: 6px;
        }
        .suffix {
          margin-left: 8px;
          position: relative;
          top: 2px;
        }
      }
    }
    .top-menu-wrapper {
      position: absolute;
      right: 440px;
      top: -1px;
      // ::v-deep .top-nav-menu.el-menu {
      //   background: none;
      //   > .el-menu-item,
      //   .el-submenu > .el-submenu__title {
      //     color: rgba(255, 255, 255, 0.8);
      //   }
      //   > .el-menu-item:hover,
      //   .el-submenu > .el-submenu__title:hover {
      //     color: rgba(255, 255, 255, 1);
      //   }
      //   .el-menu-item:hover,
      //   .el-submenu__title:hover {
      //     background: none;
      //   }
      //   .el-submenu.is-opened {
      //     background: none;
      //   }
      //   .el-submenu .el-submenu__icon-arrow {
      //     color: inherit;
      //   }
      // }
    }
    .left-over {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      background-repeat: no-repeat;
    }
    .right-over {
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      background-repeat: no-repeat;
    }
  }
  .bottom-wrapper {
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    overflow: auto;
    overflow: hidden;
    background: #f5f5f5;
    .m-test-ctn {
      width: 500px;
      height: 500px;
      background: #ffffff;
      position: fixed;
      left: 100px;
      top: 100px;
      z-index: 999;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
    }
    .sub-page-container {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      opacity: 0;
      z-index: 1;
    }
    .page-show {
      opacity: 1;
      z-index: 2;
    }
  }
  &.nav-type2,
  &.nav-type3,
  &.nav-type4 {
    .top-wrapper {
      height: $nav-height;
      .systemInfo {
        height: 100%;
        padding-top: ($nav-height - 32) / 2;
        padding-left: 8px;
      }
    }
    .bottom-wrapper {
      top: $nav-height;
    }
  }
  &.nav-type1 {
    .top-wrapper {
      height: $nav-height-l;
      position: relative;
      .systemInfo {
        height: 32px;
        padding-left: 8px;
        padding-top: 4px;
      }
      .tab-wrapper {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
      }
      .tool-bar {
        top: 6px;
      }
    }
    .bottom-wrapper {
      top: $nav-height-l;
    }
  }
  .all-menu-wrapper {
    position: absolute;
    top: 68px;
    bottom: 0;
    left: 0;
    width: 414px;
    box-shadow: 0 4px 6px 0 rgba(154, 173, 173, 0.2);
    z-index: 9999;
    translate: 0.3s;
    .u-flag {
      position: absolute;
      width: 32px;
      height: 32px;
      top: -32px;
      left: 4px;
    }
    .m-iframe-cover {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0;
      z-index: -1;
    }
  }
  .m-tool-view {
    .el-dialog__body {
      width: 100%;
      height: calc(100% - 40px);
      box-sizing: border-box;
      .el-dialog__body-wrapper {
        width: 100%;
        height: 100%;
      }
      .m-tool-frame {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.dropdown-item {
  line-height: 32px;
  font-size: 14px;
  position: relative;
  padding: 0 36px;
  .u-icon-setting {
    font-size: 24px;
    display: block;
    position: absolute;
    left: 6px;
    top: 4px;
  }
}

.slider-enter-active,
.slider-leave-active {
  transition: all 0.3s ease;
}

.slider-enter,
.slider-leave-to {
  transform: translateX(-100%);
}
::v-deep .el-dropdown-menu__item--divided:before {
  background: rgba(0, 0, 0, 0);
}
</style>
